<template>
  <div>
    <div class="main_container">
      <div class="container-fluid edit-story-wrapper" >
        <div class="borderEditView">
        <div class="panel-wrapper">
          <div class="col">
            <logicComponent>
            </logicComponent>
          </div>
        </div>
      </div>
      </div>
    </div>
  </div>
</template>
<script>
import StoryViewHeader from '../components/v2/story-edit-view/header'
import logicComponent from '../components/v2/story-edit-view/logic'
import sidebar from '../components/profile/sidebar'

export default {
  components: {
    StoryViewHeader,
    logicComponent,
    sidebar
  },
  data () {
    return {
      componentType: null,
      selectedNodeType: '',
    }
  },
  created () {
  },
  watch: {},
  mounted () {
    if (this.$route.params.category) {
      this.componentType = this.$route.params.category
    }
    this.selectedNodeType = this.$store.state.selectedLogic.category ? this.$store.state.selectedLogic.category.toLowerCase() : 'logic'
  },
  methods: {}
}
</script>
<style scoped lang="scss">

/* only wrote css for specific target */
@import '../../external_libs/frame.js/editor/css/dark.css';
@import '../../external_libs/frame.js/editor/css/main.css';

.borderEditView {
  width: 100%;
  height: 98.5%;
  //border: 1px dashed rgb(208, 244, 222);
  margin: 9px 0px 0px 1px;
  padding: 10px;
}

.edit-story-wrapper {
  padding-right: 20px;
  padding-top: 0px;
  margin: 0;
  padding: 0px 20px 0px 5px;
}

</style>



// WEBPACK FOOTER //
// src/views/logicEditView.vue